import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      nav("/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id })
      .then(({ data }) => {
        setUser(data);
        toast.success("Signed in with Google");
        // strip hash
        window.history.replaceState(null, "", window.location.pathname);
        nav("/", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      });
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <Loader2 className="animate-spin mx-auto text-primary" size={28} />
        <p className="mt-3 text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
